import Radio from 'backbone.radio';
import app_load_progress_fetch from '@/controllers/app_load_progress_fetch';
import fetch_everything from '@/controllers/fetch_everything';
import show_dialog from '@/controllers/show_dialog';
import show_overwrite_draft_dialog from '@/controllers/show_overwrite_draft_dialog';
import show_secondary_nav from '@/controllers/show_secondary_nav';
import add_popover from '@/controllers/add_popover';
import add_version_info_popover from '@/controllers/add_version_info_popover';
import change_active_account from '@/controllers/change_active_account';
import home from '@/controllers/home';
import dashboard from '@/controllers/dashboard';
import show_blinkup from '@/controllers/show_blinkup';
import show_blinkup_dialog from '@/controllers/show_blinkup_dialog';
import show_change_password_dialog from '@/controllers/show_change_password_dialog';
import show_change_account_details_dialog from '@/controllers/show_change_account_details_dialog';
import show_time_zone_options_dialog from '@/controllers/show_time_zone_options_dialog';
import show_profile from '@/controllers/show_profile';
import show_collaborators_profile from '@/controllers/show_collaborators_profile';
import show_billing from '@/controllers/show_billing';
import show_stripe_dialog from '@/controllers/show_stripe_dialog';
import show_account_secondary_nav from '@/controllers/show_account_secondary_nav';
import show_development_zone_secondary_nav from '@/controllers/show_development_zone_secondary_nav';
import show_dev_devicegroup_secondary_nav from '@/controllers/show_dev_devicegroup_secondary_nav';
import show_production_zone_secondary_nav from '@/controllers/show_production_zone_secondary_nav';
import show_test_zone_secondary_nav from '@/controllers/show_test_zone_secondary_nav';
import show_devicegroup_secondary_nav from '@/controllers/show_devicegroup_secondary_nav';
import show_code_editor from '@/controllers/show_code_editor';
import show_products from '@/controllers/show_products';
import show_product_devicegroups from '@/controllers/show_product_devicegroups';
import show_delete_product_dialog from '@/controllers/show_delete_product_dialog';
import show_product_settings_dialog from '@/controllers/show_product_settings_dialog';
import show_promote_code_dialog from '@/controllers/show_promote_code_dialog';
import show_factory_devicegroups from '@/controllers/show_factory_devicegroups';
import show_dut_devicegroups from '@/controllers/show_dut_devicegroups';
import show_pre_dut_devicegroups from '@/controllers/show_pre_dut_devicegroups';
import show_go_live from '@/controllers/show_go_live';
import show_production_device_groups from '@/controllers/show_production_device_groups';
import show_devicegroup_dashboard from '@/controllers/show_devicegroup_dashboard';
import show_delete_devicegroup_dialog from '@/controllers/show_delete_devicegroup_dialog';
import show_delete_production_device_dialog from '@/controllers/show_delete_production_device_dialog';
import show_delete_login_key_dialog from '@/controllers/show_delete_login_key_dialog';
import show_edit_login_key_dialog from '@/controllers/show_edit_login_key_dialog';
import show_devices from '@/controllers/show_devices';
import show_device_settings_dialog from '@/controllers/show_device_settings_dialog';
import show_factory_devices from '@/controllers/show_factory_devices';
import show_development_devicegroup_devices from '@/controllers/show_development_devicegroup_devices';
import show_my_development_devices from '@/controllers/show_my_development_devices';
import show_account_development_devices from '@/controllers/show_account_development_devices';
import show_pre_factoryfixture_devices from '@/controllers/show_pre_factoryfixture_devices';
import show_device from '@/controllers/show_device';
import show_create_product_dialog from '@/controllers/show_create_product_dialog';
import show_create_login_keys_dialog from '@/controllers/show_create_login_keys_dialog';
import show_account_invite_accept_dialog from '@/controllers/show_account_invite_accept_dialog';
import show_add_collaborator_dialog from '@/controllers/show_add_collaborator_dialog';
import show_remove_collaborator_dialog from '@/controllers/show_remove_collaborator_dialog';
import show_revoke_collaboration_dialog from '@/controllers/show_revoke_collaboration_dialog';
import show_resign_from_role_dialog from '@/controllers/show_resign_from_role_dialog';
import show_cancel_invitation_dialog from '@/controllers/show_cancel_invitation_dialog';
import show_collaborator_list from '@/controllers/show_collaborator_list';
import show_development_devicegroups from '@/controllers/show_development_devicegroups';
import show_create_development_devicegroup from '@/controllers/show_create_development_devicegroup';
import show_devicegroup_code_history from '@/controllers/show_devicegroup_code_history';
import ensure_login_layout from '@/controllers/ensure_login_layout';
import login from '@/controllers/login';
import reset_password from '@/controllers/reset_password';
import logout from '@/controllers/logout';
import forgot_password from '@/controllers/forgot_password';
import notfound_404 from '@/controllers/notfound_404';
import not_found from '@/controllers/not_found';
import no_access from '@/controllers/no_access';
import verify from '@/controllers/verify';
import show_new_user_imp_central_carousel from '@/controllers/new_user_imp_central_carousel';
import google_analytics from '@/controllers/google_analytics';
import show_create_deployment_dialog from '@/controllers/show_create_deployment_dialog';
import show_edit_deployment_dialog from '@/controllers/show_edit_deployment_dialog';
import show_delete_deployment_dialog from '@/controllers/show_delete_deployment_dialog';
import show_move_devices_dialog from '@/controllers/show_move_devices_dialog';
import show_assign_devices_dialog from '@/controllers/show_assign_devices_dialog';
import show_factory_device_group_settings_dialog from '@/controllers/show_factory_device_group_settings_dialog';
import show_create_factory_device_group_dialog from '@/controllers/show_create_factory_device_group_dialog';
import show_production_device_group_settings_dialog from '@/controllers/show_production_device_group_settings_dialog';
import show_create_pre_production_devicegroup from '@/controllers/show_create_pre_production_devicegroup.js';
import show_pre_production_devicegroups from '@/controllers/show_pre_production_devicegroups';
import show_pre_factoryfixture_devicegroups from '@/controllers/show_pre_factoryfixture_devicegroups';
import connect_logstream from '@/controllers/connect_logstream';
import show_create_production_devicegroup from '@/controllers/show_create_production_devicegroup';
import show_create_dut_devicegroup from '@/controllers/show_create_dut_devicegroup';
import show_create_pre_dut_devicegroup from '@/controllers/show_create_pre_dut_devicegroup';
import show_dut_device_group_settings from '@/controllers/show_dut_device_group_settings';
import show_pre_dut_device_group_settings from '@/controllers/show_dut_device_group_settings';
import show_development_devicegroup_settings_dialog from '@/controllers/show_development_devicegroup_settings_dialog';
import show_change_email_dialog from '@/controllers/show_change_email_dialog';
import show_production_devices from '@/controllers/show_production_devices';
import show_pre_production_devices from '@/controllers/show_pre_production_devices';
import show_dut_devices from '@/controllers/show_dut_devices';
import show_pre_dut_devices from '@/controllers/show_pre_dut_devices';
import show_upgrade_devices_dialog from '@/controllers/show_upgrade_devices_dialog';
import show_login_keys from '@/controllers/show_login_keys';
import show_mfa from '@/controllers/show_mfa';
import show_notifications_profile from '@/controllers/show_notifications_profile';
import show_profile_nav from '@/controllers/show_profile_nav';
import show_mfa_login from '@/controllers/show_mfa_login';
import show_mfa_recovery_keys from '@/controllers/show_mfa_recovery_keys';
import show_remove_payment_dialog from '@/controllers/show_remove_payment_dialog';
import show_notification_dialog from '@/controllers/show_notification_dialog';
import update_main_nav from '@/controllers/update_main_nav';
import show_confirm_and_pay_dialog from '@/controllers/show_confirm_and_pay_dialog';
import show_clone_devicegroup from '@/controllers/clone_devicegroup';
import show_invoice from '@/controllers/show_invoice';


const globalCh = Radio.channel('global');

var controller = {
    app_load_progress_fetch: app_load_progress_fetch,
    fetchEverything: fetch_everything,
    showDialog: show_dialog,
    showOverwriteDraftDialog: show_overwrite_draft_dialog,
    show_secondary_nav: show_secondary_nav,
    show_profile_nav: show_profile_nav,
    show_mfa_login: show_mfa_login,
    show_mfa_recovery_keys: show_mfa_recovery_keys,
    addPopover: add_popover,
    addVersionInfoPopover: add_version_info_popover,
    changeActiveAccount: change_active_account,
    home: home,
    dashboard: dashboard,
    show_blinkup: show_blinkup,
    show_profile: show_profile,
    show_billing: show_billing,
    show_stripe_dialog: show_stripe_dialog,
    show_collaborators_profile: show_collaborators_profile,
    show_login_keys: show_login_keys,
    show_notifications_profile: show_notifications_profile,
    show_mfa: show_mfa,

    show_change_password_dialog: show_change_password_dialog,
    show_change_account_details_dialog: show_change_account_details_dialog,
    show_time_zone_options_dialog: show_time_zone_options_dialog,
    show_account_secondary_nav: show_account_secondary_nav,
    show_development_zone_secondary_nav: show_development_zone_secondary_nav,
    show_dev_devicegroup_secondary_nav: show_dev_devicegroup_secondary_nav,
    show_production_zone_secondary_nav: show_production_zone_secondary_nav,
    show_test_zone_secondary_nav,
    show_devicegroup_secondary_nav: show_devicegroup_secondary_nav,

    showCodeEditor: show_code_editor,
    showProducts: show_products,
    show_product_devicegroups: show_product_devicegroups,
    showPromoteCodeDialog: show_promote_code_dialog,
    showDeleteProductDialog: show_delete_product_dialog,
    showProductSettingsDialog: show_product_settings_dialog,
    show_factory_device_group_settings_dialog: show_factory_device_group_settings_dialog,
    show_create_factory_device_group_dialog: show_create_factory_device_group_dialog,
    show_factory_devicegroups: show_factory_devicegroups,
    show_dut_devicegroups: show_dut_devicegroups,
    show_pre_dut_devicegroups: show_pre_dut_devicegroups,
    show_go_live: show_go_live,
    show_production_devicegroups: show_production_device_groups,
    show_devicegroup_dashboard: show_devicegroup_dashboard,
    show_delete_devicegroup_dialog: show_delete_devicegroup_dialog,
    show_delete_production_device_dialog: show_delete_production_device_dialog,
    show_delete_login_key_dialog: show_delete_login_key_dialog,
    show_edit_login_key_dialog: show_edit_login_key_dialog,
    show_devices: show_devices,
    show_device_settings_dialog: show_device_settings_dialog,
    show_factory_devices: show_factory_devices,
    show_development_devicegroup_devices: show_development_devicegroup_devices,
    show_my_development_devices: show_my_development_devices,
    show_account_development_devices: show_account_development_devices,
    show_pre_factoryfixture_devices: show_pre_factoryfixture_devices,
    show_device: show_device,
    show_production_devices: show_production_devices,
    show_pre_production_devices: show_pre_production_devices,
    show_dut_devices: show_dut_devices,
    show_pre_dut_devices: show_pre_dut_devices,
    showCreateProductDialog : show_create_product_dialog,
    show_create_login_keys_dialog: show_create_login_keys_dialog,
    // this is legacy, we need to figure out this
    activeDeviceLog: '',
    showAccountInviteAcceptDialog : show_account_invite_accept_dialog,
    show_add_collaborator_dialog: show_add_collaborator_dialog,
    showRemoveCollaboratorDialog: show_remove_collaborator_dialog,
    show_revoke_collaboration_dialog: show_revoke_collaboration_dialog,
    show_resign_from_role_dialog,
    showCancelInvitationDialog: show_cancel_invitation_dialog,
    showCreateDeployment: show_create_deployment_dialog,
    show_create_deployment_dialog: show_create_deployment_dialog,
    show_edit_deployment_dialog: show_edit_deployment_dialog,
    show_delete_deployment_dialog: show_delete_deployment_dialog,
    showProductionDeviceGroupSettingsDialog: show_production_device_group_settings_dialog,
    show_create_pre_production_devicegroup: show_create_pre_production_devicegroup,
    show_blinkup_dialog: show_blinkup_dialog,

    show_move_devices_dialog: show_move_devices_dialog,
    show_development_devicegroup_settings_dialog: show_development_devicegroup_settings_dialog,
    show_assign_devices_dialog: show_assign_devices_dialog,
    show_production_device_group_settings_dialog: show_production_device_group_settings_dialog,
    show_create_production_devicegroup: show_create_production_devicegroup,
    show_create_dut_devicegroup: show_create_dut_devicegroup,
    show_create_pre_dut_devicegroup: show_create_pre_dut_devicegroup,
    show_dut_device_group_settings: show_dut_device_group_settings,
    show_pre_dut_device_group_settings: show_pre_dut_device_group_settings,
    show_upgrade_devices_dialog: show_upgrade_devices_dialog,
    show_change_email_dialog: show_change_email_dialog,

    showCollaboratorList: show_collaborator_list,

    show_development_devicegroups: show_development_devicegroups,
    show_pre_production_devicegroups: show_pre_production_devicegroups,
    show_pre_factoryfixture_devicegroups: show_pre_factoryfixture_devicegroups,
    show_create_development_devicegroup: show_create_development_devicegroup,
    show_devicegroup_code_history: show_devicegroup_code_history,

    ensure_login_layout: ensure_login_layout,
    login: login,
    reset_password: reset_password,
    logout: logout,
    forgot_password: forgot_password,
    notfound_404: notfound_404,
    not_found: not_found,
    no_access: no_access,
    verify: verify,
    showNewUserImpCentralCarousel: show_new_user_imp_central_carousel,
    GA_Event: google_analytics,
    connect_logstream: connect_logstream,
    show_remove_payment_dialog,
    show_notification_dialog,
    update_main_nav: update_main_nav,
    show_confirm_and_pay_dialog,
    show_clone_devicegroup: show_clone_devicegroup,
    show_invoice: show_invoice
};

function ensure_account_loaded(account) {
    var active_account = globalCh.request('active_account');

    return new Promise(function(resolve) {
        if (account.id === active_account.id) {
            resolve(account);
            return;
        }

        globalCh.request('changeActiveAccount', account, resolve);
    });
}

globalCh.reply('ensure_account_loaded', ensure_account_loaded);
export default controller;
